import { createFileRoute } from '@tanstack/react-router';

import { CheckoutReturnPage } from '@/features/setting/page/checkout-return-page';
import z from 'zod';

const searchParams = z.object({
  session_id: z.string(),
});

export const Route = createFileRoute('/checkout/return')({
  validateSearch: searchParams,
  component: RouteComponent,
});

function RouteComponent() {
  return <CheckoutReturnPage />;
}
